import { Image, LoadingSpinner, PageFooter, Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { PageContent } from "@src/appV2/redesign/WorkerShifts/components/PageContent";

interface ProfileWorkBadgesInfoProps {
  onGetStarted: () => void;
  isLoading: boolean;
}

export function ProfileWorkBadgesInfo(props: ProfileWorkBadgesInfoProps) {
  const { onGetStarted, isLoading } = props;

  if (isLoading) {
    return (
      <Stack spacing={3} alignItems="center" justifyContent="center" height="100%" width="100%">
        <LoadingSpinner size="large" />
      </Stack>
    );
  }

  return (
    <>
      <StickyScrollPageHeader title="" headerVariant="tertiary" />
      <PageContent>
        <Stack alignItems="center" spacing={3}>
          <Stack alignItems="center">
            <Title component="h3">Create your own</Title>
            <Title component="h3">Clipboard Work Badge!</Title>
          </Stack>

          <Image src="/assets/images/work-badge.png" alt="Create Work Badge" />

          <Text bold variant="body1" sx={{ textAlign: "center" }}>
            Many workplaces require a badge to be worn when working. Let&apos;s create yours in just
            a few steps.
          </Text>
        </Stack>
      </PageContent>
      <PageFooter>
        <Button fullWidth size="large" onClick={onGetStarted}>
          Get Started
        </Button>
      </PageFooter>
    </>
  );
}
